import Input from "../../../../Core/Fields/Floating/Input";

const TaxDetails = ({ formData, errors }) => {

  return (
    <div className="row mb-3" style={{ border: "1px solid #00000059", borderRadius: "5px" }}>
      <div className="col-12">
        <p className="boxLabel m-0">Tax Details</p>
      </div>

      <div className="col-4">
        <div className="mb-3">
          <Input
            id="gstinUin"
            label="GSTIN/UIN"
            readOnly
            style={{ height: "30px", border: errors.gstinUin ? "1px solid red" : "" }}
            value={formData.gstinUin}
          />
        </div>
      </div>
      
      <div className="col-4">
        <div className="mb-3">
          <Input
            id="pan"
            label="PAN"
            readOnly
            style={{ height: "30px", border: errors.pan ? "1px solid red" : "" }}
            value={formData.pan}
          />
        </div>
      </div>
      
      <div className="col-4">
        <div className="mb-3">
           <Input
            id="pan"
            label="GST Category"
            readOnly
            style={{ height: "30px", border: errors.pan ? "1px solid red" : "" }}
            value={formData.pan}
          />
        
        </div>
      </div>
    </div>
  );
};

export default TaxDetails;